import { __decorate } from "tslib";
import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import User from "@/components/User.vue";
import TeamSelect from "@/components/TeamSelect.vue";
let EditableUser = class EditableUser extends Vue {
    value;
    editMode = false;
    teamParams = { query: { public: true } };
    emitInput(val) {
        this.editMode = false;
        return val;
    }
};
__decorate([
    Prop({ type: String, required: true })
], EditableUser.prototype, "value", void 0);
__decorate([
    Emit('input')
], EditableUser.prototype, "emitInput", null);
EditableUser = __decorate([
    Component({
        components: { TeamSelect, User }
    })
], EditableUser);
export default EditableUser;
